module.exports = __webpack_public_path__ + "static/malory_wheeler-064991e0cd0992844f8d9ffbc1194af8.jpg";